import { zodResolver } from '@hookform/resolvers/zod'
import { Control, useForm } from 'react-hook-form'

import { GiftWithPurchaseCampaignDetail, GiftWithPurchaseCampaignDetailInput } from '../schemas'

export type CreateFormProps = {
    type: 'create'
    storeId: number
}

export type EditFormProps = {
    type: 'edit'
    defaultValues: GiftWithPurchaseCampaignDetail
}

export function useGiftWithPurchaseForm(props: CreateFormProps | EditFormProps) {
    const storeId = props.type === 'create' ? props.storeId : props.defaultValues.store

    return useForm<GiftWithPurchaseCampaignDetailInput>({
        resolver: zodResolver(GiftWithPurchaseCampaignDetailInput),
        defaultValues:
            props.type === 'create'
                ? {
                      store: storeId,
                      name: '',
                      start_date: undefined,
                      end_date: undefined,
                      status: undefined,
                      is_active: true,
                      can_be_combined: false,
                      applies_to_all_products: false,
                      tiers: [
                          {
                              gifts: [],
                              limit_per_customer: 0,
                              max_redemptions: 0,
                              num_items_threshold: 0,
                              num_redeemed: 0,
                              spend_threshold: 0,
                              campaign_type: 'spend',
                          },
                      ],
                      gift_with_purchase_campaign_products: [],
                      shop_pks: [],
                  }
                : {
                      ...props.defaultValues,
                      tiers: props.defaultValues.tiers.map((tier) => ({
                          ...tier,
                          campaign_type:
                              tier.spend_threshold > 0 ? ('spend' as const) : ('items' as const),
                          gifts: tier.gifts.map((gift) => ({
                              ...gift,
                              stock_item_id: gift.stock_item.id,
                          })),
                      })),
                      shop_pks: props.defaultValues.shop_pks.map((shop_pk) => ({
                          id: shop_pk,
                      })),
                  },
    })
}

export type GiftWithPurchaseControl = Control<GiftWithPurchaseCampaignDetailInput>
